<template>

  <el-row>
    <el-col v-for="(m, i) in ma" :key="i" :span="span">
      <div :class="'month-box month' + i"><b>{{formatNumber(m, 1)}}</b> {{plural('year', m)}}</div>
    </el-col>
  </el-row>

</template>


<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {

  mixins: [NumberMixins],

  props: {
    months: {
      type: Array
    },

    maxMonths: {
      type: Number,
      required: true
    },

    periods: {
      type: Number,
      default: 3
    }

  },


  methods: {

    calcYear(m1, m2) {
      return (m2 - m1) / 12
    },

    calcMonths () {
      let m1 = this.months[0]
      let m2 = this.months[1]
      this.ma = []

      if (m1 === 0) {
         this.ma.push(this.calcYear(m1, m2))

      } else {

        this.span = 12
        this.ma.push(this.calcYear(0, m1))
        this.ma.push(this.calcYear(m1, m2))

        if (this.periods === 3) {
          this.span = 8
          this.ma.push(this.calcYear(m2, this.maxMonths))
        }
      }

    }
  },


  watch: {
    months (val) {
      this.calcMonths()
    }
  },


  data () {
    return {
      span: 24,
      ma: []
    }

  },

  created () {
    this.calcMonths ()
  }

}
</script>

<style scoped>

.month-box {
  padding: 9.6px;
  border-radius: 2px;
}

.month0 {
  background: #409EFF28;
}

.month1 {
  background:  #67C23A28;
}

.month2 {
  background: #E6A23C28;
}

</style>



// WEBPACK FOOTER //
// Timeline.vue?43606c41